import { forwardRef } from 'react';
import { Slider, Box, SliderProps } from '@mui/material';

const TrackBar = forwardRef<HTMLSpanElement, SliderProps>((props, ref) => {
    const { sx = {} } = props;
    return (
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'row', position: 'relative' }}>
            <Slider
                {...props}
                ref={ref}
                size="small"
                onTouchStart={(e) => {
                    e.nativeEvent.stopImmediatePropagation();
                  }}
                sx={{
                    zIndex: 999999,
                    color: '#f5f5f5',
                    p: 0,
                    '&:hover': {
                        '& .MuiSlider-track': {
                            height: 4,
                            borderRadius: 4,
                        },
                        '& .MuiSlider-thumb': {
                            height: 14,
                            width: 14,
                            backgroundColor: '#fff',
                        },
                        color: '#fff',
                    },
                    '&:focus, &:hover, &$active': {
                        boxShadow: 'inherit',
                    },
                    '& .MuiSlider-thumb': {
                        backgroundColor: '#fff',
                        '&:focus, &:hover, &.Mui-active': {
                            boxShadow: 'inherit',
                        },
                    },
                    '& .MuiSlider-valueLabel': {
                        left: 'calc(-50% + 4px)',
                    },
                    ...sx,
                }}
            />
        </Box>
    );
});

export default TrackBar;
